var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { commonCssStyles } from "../../global-styles.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { msg } from "@lit/localize";
import "../nav-menu-avatar-button/NavMenuAvatarButton.js";
import "../nav-menu-icon-button/NavMenuIconButton.js";
import "../nav-menu-text-button/NavMenuTextButton.js";
import "../mobile-menu-button/MobileMenuButton.js";
import { classMap } from "lit/directives/class-map.js";
import { HeaderEvent, headerEventFn } from "../header/ESHeader.js";
import { AbstractDropdown } from "../dropdown-menu-mixin/AbstractDropdown.js";
/**
 * @fires CustomEvent#DASHBOARD_CLICKED
 * @fires CustomEvent#MY_TESTS_CLICKED
 * @fires CustomEvent#BILLING_CLICKED
 * @fires CustomEvent#SUPPORT_CLICKED
 * @fires CustomEvent#MY_PROFILE_CLICKED
 * @fires CustomEvent#LOG_OUT_CLICKED
 */
let MobileMenu = class MobileMenu extends AbstractDropdown(LitElement) {
    constructor() {
        super(...arguments);
        this.alert = false;
        this._disableScrollStyleElement = this.buildDisableScrollStyleElement();
    }
    _menuItemEventFn(eventType) {
        /*
        https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/menu_role
        When a user activates a choice in a menu that has been opened, the menu usually closes
         */
        return (event) => {
            headerEventFn(this, eventType)();
            this.toggleScrollAndDrawer(event);
        };
    }
    get dropdownContainerElement() {
        return this.shadowRoot.getElementById("dropdown-menu-mobile");
    }
    focusMenuButton() {
        this.shadowRoot.getElementById("menu-btn").focus();
    }
    focusFirstDropdownItem() {
        this.shadowRoot.querySelector("nav-menu-text-button").focus();
    }
    buildDisableScrollStyleElement() {
        const styleElement = document.createElement("style");
        styleElement.innerHTML = css `
      body {
        height: 100vh;
        width: 100vw;
        overflow: hidden;
      }
    `.toString();
        return styleElement;
    }
    toggleScrollAndDrawer(event) {
        this.toggleDropdown(event);
        if (this.open) {
            this.disableScroll();
        }
        else {
            this.reEnableScroll();
        }
    }
    disableScroll() {
        document.head.appendChild(this._disableScrollStyleElement);
    }
    reEnableScroll() {
        document.head.removeChild(this._disableScrollStyleElement);
    }
    render() {
        return html `
      <div class="container">
        <div class="menu-button">
          <mobile-menu-button
            id="menu-btn"
            ?open="${this.open}"
            aria-haspopup="true"
            aria-expanded="${this.open}"
            aria-controls="dropdown-menu-mobile"
            @click="${this.toggleScrollAndDrawer}"
          >
          </mobile-menu-button>
        </div>
        <div class="menu-visible-container ${classMap({ hide: !this.open })}">
          <div
            class="mobile-menu-blur ${classMap({ hide: !this.open })}"
            aria-hidden="true"
          ></div>
          <div
            id="dropdown-menu-mobile"
            class="mobile-menu ${classMap({ hide: !this.open })}"
            role="menu"
            aria-hidden="${!this.open}"
          >
            <div class="menu-composition">
              <div class="mobile-menu-inner">
                <div class="nav-wrapper">
                  <nav-menu-text-button
                    class="menu-option"
                    text="${msg("Dashboard")}"
                    @click="${this._menuItemEventFn(HeaderEvent.DASHBOARD_CLICKED)}"
                  ></nav-menu-text-button>

                  <nav-menu-text-button
                    class="menu-option"
                    text="${msg("My tests")}"
                    @click="${this._menuItemEventFn(HeaderEvent.MY_TESTS_CLICKED)}"
                  ></nav-menu-text-button>

                  <nav-menu-text-button
                    class="menu-option"
                    text="${msg("Billing")}"
                    @click="${this._menuItemEventFn(HeaderEvent.BILLING_CLICKED)}"
                  ></nav-menu-text-button>

                  <nav-menu-text-button
                    class="menu-option"
                    text="${msg("Support")}"
                    @click="${this._menuItemEventFn(HeaderEvent.SUPPORT_CLICKED)}"
                  ></nav-menu-text-button>
                </div>

                <hr class="divider" role="separator" aria-hidden="true" />

                <nav-menu-avatar-button
                  class="menu-option"
                  text="${msg("My profile")}"
                  initials="${ifDefined(this.userInitials)}"
                  ?alert="${this.alert}"
                  @click="${this._menuItemEventFn(HeaderEvent.MY_PROFILE_CLICKED)}"
                ></nav-menu-avatar-button>

                <hr class="divider" role="separator" aria-hidden="true" />

                <nav-menu-icon-button
                  class="menu-option"
                  text="${msg("Log out")}"
                  @click="${this._menuItemEventFn(HeaderEvent.LOG_OUT_CLICKED)}"
                >
                  <svg
                    slot="icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M22.0999 12.9241L16.8473 18.067C16.3549 18.5893 15.4932 18.5893 15.0007 18.067C14.4673 17.5848 14.4673 16.7411 15.0007 16.2589L17.9963 13.2857H9.37885C8.64021 13.2857 8.06571 12.7232 8.06571 12C8.06571 11.317 8.64021 10.7143 9.37885 10.7143H17.9963L15.0007 7.78125C14.4673 7.29911 14.4673 6.45536 15.0007 5.97321C15.4932 5.45089 16.3549 5.45089 16.8473 5.97321L22.0999 11.1161C22.6334 11.5982 22.6334 12.442 22.0999 12.9241ZM8.06571 5.57143H5.43942C4.70078 5.57143 4.12628 6.17411 4.12628 6.85714V17.1429C4.12628 17.8661 4.70078 18.4286 5.43942 18.4286H8.06571C8.76331 18.4286 9.37885 19.0312 9.37885 19.7143C9.37885 20.4375 8.76331 21 8.06571 21H5.43942C3.26453 21 1.5 19.2723 1.5 17.1429V6.85714C1.5 4.72768 3.26453 3 5.43942 3H8.06571C8.76331 3 9.37885 3.60268 9.37885 4.28571C9.37885 5.00893 8.76331 5.57143 8.06571 5.57143Z"
                    />
                  </svg>
                </nav-menu-icon-button>
              </div>

              <svg
                class="watermark-gradient"
                aria-hidden="true"
                focusable="false"
              >
                <linearGradient
                  id="watermark-gradient"
                  gradientTransform="rotate(67)"
                >
                  <stop offset="27.89%" stop-color="#000" stop-opacity="0" />
                  <stop offset="100%" stop-color="#000" stop-opacity="1" />
                </linearGradient>
              </svg>

              <svg
                class="dna-watermark"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="217"
                viewBox="0 0 200 217"
                fill="url(#watermark-gradient) #4D4D4D"
                aria-hidden="true"
              >
                <path
                  d="M199.984 27.9699C206.765 32.9961 209.58 37.7013 209.58 44.231H219.815C219.815 34.8121 214.181 27.7873 207.295 22.5823C214.156 17.3553 219.88 9.59654 219.815 0.268433H209.579C209.646 6.77517 206.721 12.1685 199.984 17.1967C193.246 12.1685 190.322 6.77517 190.387 0.268433H180.152C180.152 9.59654 185.814 17.3553 192.672 22.5823C185.786 27.7873 180.152 34.8121 180.152 44.231H190.388C190.388 37.7013 193.202 32.9961 199.984 27.9699ZM199.984 76.7138C206.765 81.74 209.58 86.4452 209.58 92.9749H219.815C219.815 83.556 214.181 76.5312 207.295 71.3262C214.156 66.0992 219.88 58.3404 219.815 49.0123H209.579C209.646 55.5191 206.721 60.9124 199.984 65.9406C193.246 60.9124 190.322 55.5191 190.387 49.0123H180.152C180.152 58.3404 185.814 66.0992 192.672 71.3262C185.786 76.5312 180.152 83.556 180.152 92.9749H190.388C190.388 86.4452 193.202 81.74 199.984 76.7138ZM119.815 190.461C119.815 183.931 117 179.226 110.219 174.2C103.437 179.226 100.623 183.931 100.623 190.461H90.387C90.387 181.042 96.0213 174.017 102.907 168.812C96.0495 163.585 90.387 155.826 90.387 146.498H100.622C100.557 153.005 103.481 158.398 110.219 163.427C116.956 158.398 119.881 153.005 119.814 146.498H130.05C130.115 155.826 124.391 163.585 117.53 168.812C124.416 174.017 130.05 181.042 130.05 190.461H119.815ZM199.984 174.2C206.765 179.226 209.58 183.931 209.58 190.461H219.815C219.815 181.042 214.181 174.017 207.295 168.812C214.156 163.585 219.88 155.826 219.815 146.498H209.579C209.646 153.005 206.721 158.398 199.984 163.427C193.246 158.398 190.322 153.005 190.387 146.498H180.152C180.152 155.826 185.814 163.585 192.672 168.812C185.786 174.017 180.152 181.042 180.152 190.461H190.388C190.388 183.931 193.202 179.226 199.984 174.2ZM199.984 222.943C206.765 227.969 209.58 232.674 209.58 239.204H219.815C219.815 229.785 214.181 222.76 207.295 217.555C214.156 212.328 219.88 204.57 219.815 195.242H209.579C209.646 201.748 206.721 207.142 199.984 212.17C193.246 207.142 190.322 201.748 190.387 195.242H180.152C180.152 204.57 185.814 212.328 192.672 217.555C185.786 222.76 180.152 229.785 180.152 239.204H190.388C190.388 232.674 193.202 227.969 199.984 222.943ZM155.101 222.943C161.882 227.969 164.697 232.674 164.697 239.204H174.932C174.932 229.785 169.298 222.76 162.413 217.555C169.273 212.328 174.997 204.57 174.932 195.242H164.696C164.763 201.748 161.839 207.142 155.101 212.17C148.363 207.142 145.439 201.748 145.504 195.242H135.269C135.269 204.57 140.932 212.328 147.789 217.555C140.903 222.76 135.269 229.785 135.269 239.204H145.506C145.506 232.674 148.32 227.969 155.101 222.943ZM119.815 239.204C119.815 232.674 117 227.969 110.219 222.943C103.437 227.969 100.623 232.674 100.623 239.204H90.387C90.387 229.785 96.0213 222.76 102.907 217.555C96.0495 212.328 90.387 204.57 90.387 195.242H100.622C100.557 201.748 103.481 207.142 110.219 212.17C116.956 207.142 119.881 201.748 119.814 195.242H130.05C130.115 204.57 124.391 212.328 117.53 217.555C124.416 222.76 130.05 229.785 130.05 239.204H119.815ZM20.4538 222.943C27.2352 227.969 30.0503 232.674 30.0503 239.204H40.2845C40.2845 229.785 34.6513 222.76 27.7654 217.555C34.6262 212.328 40.3503 204.57 40.2845 195.242H30.0492C30.116 201.748 27.1914 207.142 20.4538 212.17C13.7162 207.142 10.7915 201.748 10.8572 195.242H0.621948C0.621948 204.57 6.28445 212.328 13.1421 217.555C6.25626 222.76 0.621948 229.785 0.621948 239.204H10.8583C10.8583 232.674 13.6723 227.969 20.4538 222.943ZM164.697 190.461C164.697 183.931 161.882 179.226 155.101 174.2C148.32 179.226 145.506 183.931 145.506 190.461H135.269C135.269 181.042 140.903 174.017 147.789 168.812C140.932 163.585 135.269 155.826 135.269 146.498H145.504C145.439 153.005 148.363 158.398 155.101 163.427C161.839 158.398 164.763 153.005 164.696 146.498H174.932C174.997 155.826 169.273 163.585 162.413 168.812C169.298 174.017 174.932 181.042 174.932 190.461H164.697ZM209.58 141.718C209.58 135.188 206.765 130.483 199.984 125.456C193.202 130.483 190.388 135.188 190.388 141.718H180.152C180.152 132.299 185.786 125.274 192.672 120.069C185.814 114.842 180.152 107.083 180.152 97.755H190.387C190.322 104.262 193.246 109.655 199.984 114.683C206.721 109.655 209.646 104.262 209.579 97.755H219.815C219.88 107.083 214.156 114.842 207.295 120.069C214.181 125.274 219.815 132.299 219.815 141.718H209.58ZM155.101 76.7138C161.882 81.74 164.697 86.4452 164.697 92.9749H174.932C174.932 83.556 169.298 76.5312 162.413 71.3262C169.273 66.0992 174.997 58.3404 174.932 49.0123H164.696C164.763 55.5191 161.839 60.9124 155.101 65.9406C148.363 60.9124 145.439 55.5191 145.504 49.0123H135.269C135.269 58.3404 140.932 66.0992 147.789 71.3262C140.903 76.5312 135.269 83.556 135.269 92.9749H145.506C145.506 86.4452 148.32 81.74 155.101 76.7138ZM164.697 141.718C164.697 135.188 161.882 130.483 155.101 125.456C148.32 130.483 145.506 135.188 145.506 141.718H135.269C135.269 132.299 140.903 125.274 147.789 120.069C140.932 114.842 135.269 107.083 135.269 97.755H145.504C145.439 104.262 148.363 109.655 155.101 114.683C161.839 109.655 164.763 104.262 164.696 97.755H174.932C174.997 107.083 169.273 114.842 162.413 120.069C169.298 125.274 174.932 132.299 174.932 141.718H164.697ZM110.219 125.456C117 130.483 119.815 135.188 119.815 141.718H130.05C130.05 132.299 124.416 125.274 117.53 120.069C124.391 114.842 130.115 107.083 130.05 97.755H119.814C119.881 104.262 116.956 109.655 110.219 114.683C103.481 109.655 100.557 104.262 100.622 97.755H90.387C90.387 107.083 96.0495 114.842 102.907 120.069C96.0213 125.274 90.387 132.299 90.387 141.718H100.623C100.623 135.188 103.437 130.483 110.219 125.456ZM74.9324 92.9749C74.9324 86.4452 72.1174 81.74 65.3359 76.7138C58.5545 81.74 55.7405 86.4452 55.7405 92.9749H45.5042C45.5042 83.556 51.1385 76.5312 58.0243 71.3262C51.1666 66.0992 45.5042 58.3404 45.5042 49.0123H55.7394C55.6737 55.5191 58.5984 60.9124 65.3359 65.9406C72.0735 60.9124 74.9982 55.5191 74.9314 49.0123H85.1667C85.2324 58.3404 79.5084 66.0992 72.6476 71.3262C79.5334 76.5312 85.1667 83.556 85.1667 92.9749H74.9324Z"
                  fill-opacity="0.05"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    `;
    }
};
// noinspection CssUnresolvedCustomProperty
MobileMenu.styles = [
    commonCssStyles,
    css `
      .container {
        width: fit-content;
      }

      .menu-button {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 52px;
      }

      /* a mask to only show the mobile menu on screen*/
      .menu-visible-container {
        visibility: hidden;
        position: absolute;
        top: 53px;
        height: calc(100vh - 53px);
        left: 0;
        right: 0;
        overflow: hidden;
      }

      .mobile-menu-blur {
        display: flex;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        backdrop-filter: blur(2px);
        position: absolute;
        top: 0;
        right: 0;
        transition: var(--dropdown-transition);
        visibility: visible;
      }

      .menu-composition {
        flex: 1;
        position: relative;
      }

      .mobile-menu {
        display: flex;
        flex-direction: column;
        width: calc(100% - 24px);
        height: 100%;
        top: 0;
        right: 0;
        z-index: 100;
        background: var(--white-color);
        position: absolute;
        transform: translateX(0);
        transition: var(--dropdown-transition);
        visibility: visible;
        overflow-y: scroll;
      }

      .watermark-gradient {
        width: 0;
        height: 0;
        position: absolute;
      }

      .dna-watermark {
        width: 200px;
        height: 217px;
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .mobile-menu-inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px;
        gap: 24px;
        position: relative;
      }

      .nav-wrapper {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
      }

      .menu-option {
        width: 100%;
      }

      .divider {
        width: 100%;
        height: 1px;
        border: none;
        margin: 0;
        background-color: var(--neutral-dark-20-color);
      }

      .mobile-menu-blur.hide {
        visibility: hidden;
        background: rgba(0, 0, 0, 0);
      }

      .mobile-menu.hide {
        visibility: hidden;
        transform: translateX(100%);
      }
    `,
];
__decorate([
    property({ attribute: "user-initials" })
], MobileMenu.prototype, "userInitials", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], MobileMenu.prototype, "alert", void 0);
MobileMenu = __decorate([
    customElement("mobile-menu")
], MobileMenu);
export { MobileMenu };
